<template>
  <div
    v-if="!RoutePermission(false,'','','dashboard','total_receivables')&&!RoutePermission(false,'','','dashboard','sales')&&!RoutePermission(false,'','','dashboard','sales_rec_due')"
  >
     <RecordNotFound :message="'You do not have permission to perform this operation. Please contact your Administrator.'"></RecordNotFound>
  </div>
  <div class="dashboard-layout" v-else>
    <div class="dashbord-content pl-0 pr-4 pb-4">
      <b-row v-if="RoutePermission(false,'','','dashboard','total_receivables')">
        <b-col lg="12" md="12" sm="12" xs="12">
          <div class="pb-3 h-100">
            <Widget class="h-100 mb-0" title="Total Receivables">
              <b-row>
                <b-col xs="12" md="6" lg="6" class="p-0">
                  <div class="text-truncate mb-4 text-left text-sm ml-4 mt-3">
                    Total Unpaid Invoices :
                    <router-link
                      :to="{name:'AgingDetailsReport',query:{filter_by : '',interval_range:15,number_of_columns:4}}"
                      class="text-dark"
                    >{{ orgCurrencySymbol }} {{ CheckNan(list.due_amount.total_receivable).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                  </div>
                  <div ref="invoicechartContainer" style="width: 100%; height: 100px" />
                </b-col>
                <b-col xs="12" md="6" lg="6" class="p-0 pl-2 justify-content-center chart-table">
                  <div>
                    <table style="font-size:smaller;color:#545454">
                      <tbody>
                        <tr>
                          <td class="legendColorBox">
                            <div style="border:1px solid #ccc;padding:1px">
                              <div
                                style="width:4px;height:0;border:5px solid #c9e7b8;overflow:hidden"
                              ></div>
                            </div>
                          </td>
                          <td class="legendLabel">
                            <router-link
                              class="text-decoration-none text-gray"
                              :to="{name:'AgingDetailsReport',query:{filter_by:'current'}}"
                            >
                              <span
                                class="fw-semi-bold text-muted"
                                style="width:100px !important"
                              >Current</span>
                              <span
                                class="text-truncate fw-semi-bold pl-2"
                                style="font-size:12.7px;"
                              >{{ orgCurrencySymbol }} {{ CheckNan(list.due_amount.due_date_amt).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                            </router-link>
                          </td>
                        </tr>
                        <tr>
                          <td class="legendColorBox">
                            <div style="border:1px solid #ccc;padding:1px">
                              <div
                                style="width:4px;height:0;border:5px solid rgb(255,248,227);overflow:hidden"
                              ></div>
                            </div>
                          </td>
                          <td class="legendLabel">
                            <router-link
                              class="text-decoration-none text-gray"
                              :to="{name:'AgingDetailsReport',query:{filter_by:'1-15 days'}}"
                            >
                              <span
                                class="fw-semi-bold text-muted"
                                style="width:100px !important"
                              >1-15 days</span>
                              <span
                                class="text-truncate fw-semi-bold pl-2"
                                style="font-size:12.7px;"
                              >{{ orgCurrencySymbol }} {{ CheckNan(list.due_amount.overdue_1_15_amt).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                            </router-link>
                          </td>
                        </tr>
                        <tr>
                          <td class="legendColorBox">
                            <div style="border:1px solid #ccc;padding:1px">
                              <div
                                style="width:4px;height:0;border:5px solid rgb(195,231,231);overflow:hidden"
                              ></div>
                            </div>
                          </td>
                          <td class="legendLabel">
                            <router-link
                              class="text-decoration-none text-gray"
                              :to="{name:'AgingDetailsReport',query:{filter_by:'16-30 days'}}"
                            >
                              <span
                                class="fw-semi-bold text-muted"
                                style="width:100px !important"
                              >16-30 days</span>
                              <span
                                class="text-truncate fw-semi-bold pl-2"
                                style="font-size:12.7px;"
                              >{{ orgCurrencySymbol }} {{ CheckNan(list.due_amount.overdue_16_30_amt).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                            </router-link>
                          </td>
                        </tr>
                        <tr>
                          <td class="legendColorBox">
                            <div style="border:1px solid #ccc;padding:1px">
                              <div
                                style="width:4px;height:0;border:5px solid rgb(255,215,222);overflow:hidden"
                              ></div>
                            </div>
                          </td>
                          <td class="legendLabel">
                            <router-link
                              class="text-decoration-none text-gray"
                              :to="{name:'AgingDetailsReport',query:{filter_by:'31-45 days'}}"
                            >
                              <span
                                class="fw-semi-bold text-muted"
                                style="width:100px !important"
                              >31-45 days</span>
                              <span
                                class="text-truncate fw-semi-bold pl-2"
                                style="font-size:12.7px;"
                              >{{ orgCurrencySymbol }} {{ CheckNan(list.due_amount.overdue_31_45_amt).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                            </router-link>
                          </td>
                        </tr>
                        <tr>
                          <td class="legendColorBox">
                            <div style="border:1px solid #ccc;padding:1px">
                              <div
                                style="width:4px;height:0;border:5px solid rgb(226,234,255);overflow:hidden"
                              ></div>
                            </div>
                          </td>
                          <td class="legendLabel">
                            <router-link
                              class="text-decoration-none text-gray"
                              :to="{name:'AgingDetailsReport',query:{filter_by:'>45 days'}}"
                            >
                              <span
                                class="fw-semi-bold text-muted"
                                style="width:100px !important"
                              >Above 45 days</span>
                              <span
                                class="text-truncate fw-semi-bold pl-2"
                                style="font-size:12.7px;"
                              >{{ orgCurrencySymbol }} {{ CheckNan(list.due_amount.overdue_abv_45_amt).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                            </router-link>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-col>
              </b-row>
            </Widget>
          </div>
        </b-col>
        <!-- 
        <b-col lg="6" offset-lg="0" md="12" offset-md="0" sm="12" xs="12" class="pl-0">
          <div class="pb-3 h-100">
            <Widget class="h-100 mb-0" title="Total Payables">
              <b-row>
                <b-col xs="12" md="6" lg="6" class="p-0">
                  <div class="text-truncate mb-4 text-left text-sm ml-4 mt-3">
                    Total Unpaid Bills :
                    {{ orgCurrencySymbol }} {{ CheckNan(list.payable_due_amount.total_payable).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                  </div>
                  <div ref="billschartContainer" style="width: 100%; height: 100px" />
                </b-col>
                <b-col xs="12" md="6" lg="6" class="p-0 pl-2 justify-content-center chart-table">
                  <div>
                    <table style="font-size:smaller;color:#545454">
                      <tbody>
                        <tr>
                          <td class="legendColorBox">
                            <div style="border:1px solid #ccc;padding:1px">
                              <div
                                style="width:4px;height:0;border:5px solid #c9e7b8;overflow:hidden"
                              ></div>
                            </div>
                          </td>
                          <td class="legendLabel">
                            <router-link
                              class="text-decoration-none text-gray"
                              :to="{name:'VendorAgingDetailsReport',query:{filter_by:'current'}}"
                            >
                              <span
                                class="fw-semi-bold text-muted"
                                style="width:100px !important"
                              >Current</span>
                              <span
                                class="text-truncate fw-semi-bold pl-2"
                                style="font-size:12.7px;"
                              >{{ orgCurrencySymbol }} {{ CheckNan(list.payable_due_amount.due_date_amt).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                            </router-link>
                          </td>
                        </tr>
                        <tr>
                          <td class="legendColorBox">
                            <div style="border:1px solid #ccc;padding:1px">
                              <div
                                style="width:4px;height:0;border:5px solid rgb(255,248,227);overflow:hidden"
                              ></div>
                            </div>
                          </td>
                          <td class="legendLabel">
                            <router-link
                              class="text-decoration-none text-gray"
                              :to="{name:'VendorAgingDetailsReport',query:{filter_by:'1-15 days'}}"
                            >
                              <span
                                class="fw-semi-bold text-muted"
                                style="width:100px !important"
                              >1-15 days</span>
                              <span
                                class="text-truncate fw-semi-bold pl-2"
                                style="font-size:12.7px;"
                              >{{ orgCurrencySymbol }} {{ CheckNan(list.payable_due_amount.overdue_1_15_amt).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                            </router-link>
                          </td>
                        </tr>
                        <tr>
                          <td class="legendColorBox">
                            <div style="border:1px solid #ccc;padding:1px">
                              <div
                                style="width:4px;height:0;border:5px solid rgb(195,231,231);overflow:hidden"
                              ></div>
                            </div>
                          </td>
                          <td class="legendLabel">
                            <router-link
                              class="text-decoration-none text-gray"
                              :to="{name:'VendorAgingDetailsReport',query:{filter_by:'16-30 days'}}"
                            >
                              <span
                                class="fw-semi-bold text-muted"
                                style="width:100px !important"
                              >16-30 days</span>
                              <span
                                class="text-truncate fw-semi-bold pl-2"
                                style="font-size:12.7px;"
                              >{{ orgCurrencySymbol }} {{ CheckNan(list.payable_due_amount.overdue_16_30_amt).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                            </router-link>
                          </td>
                        </tr>
                        <tr>
                          <td class="legendColorBox">
                            <div style="border:1px solid #ccc;padding:1px">
                              <div
                                style="width:4px;height:0;border:5px solid rgb(255,215,222);overflow:hidden"
                              ></div>
                            </div>
                          </td>
                          <td class="legendLabel">
                            <router-link
                              class="text-decoration-none text-gray"
                              :to="{name:'VendorAgingDetailsReport',query:{filter_by:'31-45 days'}}"
                            >
                              <span
                                class="fw-semi-bold text-muted"
                                style="width:100px !important"
                              >31-45 days</span>
                              <span
                                class="text-truncate fw-semi-bold pl-2"
                                style="font-size:12.7px;"
                              >{{ orgCurrencySymbol }} {{ CheckNan(list.payable_due_amount.overdue_31_45_amt).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                            </router-link>
                          </td>
                        </tr>
                        <tr>
                          <td class="legendColorBox">
                            <div style="border:1px solid #ccc;padding:1px">
                              <div
                                style="width:4px;height:0;border:5px solid rgb(226,234,255);overflow:hidden"
                              ></div>
                            </div>
                          </td>
                          <td class="legendLabel">
                            <router-link
                              class="text-decoration-none text-gray"
                              :to="{name:'VendorAgingDetailsReport',query:{filter_by:'>45 days'}}"
                            >
                              <span
                                class="fw-semi-bold text-muted"
                                style="width:100px !important"
                              >Above 45 days</span>
                              <span
                                class="text-truncate fw-semi-bold pl-2"
                                style="font-size:12.7px;"
                              >{{ orgCurrencySymbol }} {{ CheckNan(list.payable_due_amount.overdue_abv_45_amt).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</span>
                            </router-link>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-col>
              </b-row>
            </Widget>
          </div>
        </b-col>-->
      </b-row>
      <b-row v-if="RoutePermission(false,'','','dashboard','sales')">
        <b-col lg="12" md="12" sm="12" xs="12">
          <div class="pb-3 h-100">
            <b-dropdown
              variant="light"
              :text="list.fiscal_year_type"
              size="sm"
              :class="{'float-right' : true}"
              style="padding: 15px 20px 0px 0px;z-index:10"
            >
              <b-dropdown-item @click="dashboard_graph(1)">This Fiscal Year</b-dropdown-item>
              <b-dropdown-item @click="dashboard_graph(2)">Previous Fiscal Year</b-dropdown-item>
              <b-dropdown-item @click="dashboard_graph(3)">Last 12 Months</b-dropdown-item>
            </b-dropdown>
            <Widget class="h-100 mb-0" title="Sales">
              <div class="float-left col-lg-12 col-sm-12 p-0">
                <!---->
                <div class="text-center" ref="salesreceiptbarchart" :style="{ height: '250px' }" />
              </div>
              <div class="float-left col-lg-12 col-sm-12">
                <div class="stats-row mt-4">
                  <div class="stat-item pl-3 pt-2" style="border-left: 4px solid #ffe1c3">
                    <h5>Total Sales</h5>
                    <p class="value h6 fw-semi-bold">
                      <router-link
                        class="event-link text-dark"
                        :to="{name:'SalesCustomer',query:{from_date:list.graph_start_date,to_date:list.graph_end_date}}"
                      >{{ orgCurrencySymbol }} {{ CheckNan(list.total_sales_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                    </p>
                  </div>
                  <div class="stat-item pl-3 pt-2" style="border-left: 4px solid #c0dcfd">
                    <h5>Total Receipts</h5>
                    <p class="value h6 fw-semi-bold">
                      <router-link
                        class="event-link text-dark"
                        :to="{name:'PaymentsReceivedReport',query:{from_date:list.graph_start_date,to_date:list.graph_end_date}}"
                      >{{ orgCurrencySymbol }} {{ CheckNan(list.total_receipt_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                    </p>
                    <!-- {{ list }} -->
                  </div>
                </div>
              </div>
            </Widget>
          </div>
        </b-col>
      </b-row>
      <div class="row" v-if="RoutePermission(false,'','','dashboard','sales_rec_due')">
        <div
          class="col-xl-4 offset-xl-0 col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-12 col-xs-12"
        >
          <div class="pb-4 h-auto">
            <Widget class="h-auto mb-0" title="Sales">
              <div class="d-flex justify-content-between align-items-center mb-md"></div>
              <b-row>
                <b-col cols="6">
                  <h5 class="fw-semi-bold text-muted mb-3">Today</h5>
                  <p class="text-muted mb-2 text-sm">This Week</p>
                  <p class="text-muted mb-2 text-sm">This Month</p>
                  <p class="text-muted mb-2 text-sm">This Quarter</p>
                  <p class="text-muted mb-2 text-sm">This Year</p>
                </b-col>
                <b-col cols="6">
                  <h5 class="text-truncate fw-semi-bold mb-3">
                    <router-link
                      class="event-link text-dark"
                      :to="{name:'SalesCustomer',query:{from_date:list.sal_rec_due_dates.today_dates.from_date,to_date:list.sal_rec_due_dates.today_dates.to_date}}"
                    >
                      {{ orgCurrencySymbol }} {{ CheckNan(list.sal_rec_due_amt.tday_total_amt).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                      <i
                        class="la la-arrow-right text-success rotate-315 cursor_pointer text-decoration-none"
                      />
                    </router-link>
                  </h5>
                  <p class="text-truncate mb-2 text-sm">
                    <router-link
                      class="event-link"
                      :to="{name:'SalesCustomer',query:{from_date:list.sal_rec_due_dates.this_week.from_date,to_date:list.sal_rec_due_dates.this_week.to_date}}"
                    >{{ orgCurrencySymbol }} {{ CheckNan(list.sal_rec_due_amt.week_total_amt).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                  </p>
                  <p class="text-truncate mb-2 text-sm">
                    <router-link
                      class="event-link"
                      :to="{name:'SalesCustomer',query:{from_date:list.sal_rec_due_dates.this_month.from_date,to_date:list.sal_rec_due_dates.this_month.to_date}}"
                    >{{ orgCurrencySymbol }} {{ CheckNan(list.sal_rec_due_amt.month_total_amt).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                  </p>
                  <p class="text-truncate mb-2 text-sm">
                    <router-link
                      class="event-link"
                      :to="{name:'SalesCustomer',query:{from_date:list.sal_rec_due_dates.this_quarter.from_date,to_date:list.sal_rec_due_dates.this_quarter.to_date}}"
                    >{{ orgCurrencySymbol }} {{ CheckNan(list.sal_rec_due_amt.quarter_total_amt).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                  </p>
                  <p class="text-truncate mb-2 text-sm">
                    <router-link
                      class="event-link"
                      :to="{name:'SalesCustomer',query:{from_date:list.sal_rec_due_dates.this_year.from_date,to_date:list.sal_rec_due_dates.this_year.to_date}}"
                    >{{ orgCurrencySymbol }} {{ CheckNan(list.sal_rec_due_amt.year_total_amt).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                  </p>
                </b-col>
              </b-row>
            </Widget>
          </div>
        </div>
        <div
          class="pl-0 col-xl-4 offset-xl-0 col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-12 col-xs-12"
        >
          <div class="pb-4 h-auto">
            <Widget class="h-auto mb-0" title="Receipts">
              <div class="d-flex justify-content-between align-items-center mb-md"></div>
              <b-row>
                <b-col cols="6">
                  <h5 class="fw-semi-bold text-muted mb-3">Today</h5>
                  <p class="text-muted mb-2 text-sm">This Week</p>
                  <p class="text-muted mb-2 text-sm">This Month</p>
                  <p class="text-muted mb-2 text-sm">This Quarter</p>
                  <p class="text-muted mb-2 text-sm">This Year</p>
                </b-col>
                <b-col cols="6">
                  <h5 class="text-truncate fw-semi-bold mb-3">
                    <router-link
                      class="event-link text-dark"
                      :to="{name:'PaymentsReceivedReport',query:{from_date:list.sal_rec_due_dates.today_dates.from_date,to_date:list.sal_rec_due_dates.today_dates.to_date}}"
                    >
                      {{ orgCurrencySymbol }} {{ CheckNan(list.receipt_amount.tday_paid_amt).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                      <i
                        class="la la-arrow-right text-success rotate-315 cursor_pointer text-decoration-none"
                      />
                    </router-link>
                  </h5>
                  <p class="text-truncate mb-2 text-sm">
                    <router-link
                      class="event-link"
                      :to="{name:'PaymentsReceivedReport',query:{from_date:list.sal_rec_due_dates.this_week.from_date,to_date:list.sal_rec_due_dates.this_week.to_date}}"
                    >{{ orgCurrencySymbol }} {{ CheckNan(list.receipt_amount.week_paid_amt).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                  </p>
                  <p class="text-truncate mb-2 text-sm">
                    <router-link
                      class="event-link"
                      :to="{name:'PaymentsReceivedReport',query:{from_date:list.sal_rec_due_dates.this_month.from_date,to_date:list.sal_rec_due_dates.this_month.to_date}}"
                    >{{ orgCurrencySymbol }} {{ CheckNan(list.receipt_amount.month_paid_amt).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                  </p>
                  <p class="mb-2 text-sm">
                    <router-link
                      class="event-link"
                      :to="{name:'PaymentsReceivedReport',query:{from_date:list.sal_rec_due_dates.this_quarter.from_date,to_date:list.sal_rec_due_dates.this_quarter.to_date}}"
                    >{{ orgCurrencySymbol }} {{ CheckNan(list.receipt_amount.quarter_paid_amt).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                  </p>
                  <p class="text-truncate mb-2 text-sm">
                    <router-link
                      class="event-link"
                      :to="{name:'PaymentsReceivedReport',query:{from_date:list.sal_rec_due_dates.this_year.from_date,to_date:list.sal_rec_due_dates.this_year.to_date}}"
                    >{{ orgCurrencySymbol }} {{ CheckNan(list.receipt_amount.year_paid_amt).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</router-link>
                  </p>
                </b-col>
              </b-row>
            </Widget>
          </div>
        </div>
        <div
          class="pl-0 col-xl-4 offset-xl-0 col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-12 col-xs-12"
        >
          <div class="pb-4 h-auto">
            <Widget class="h-auto mb-0" title="Dues">
              <div class="d-flex justify-content-between align-items-center mb-md"></div>
              <b-row>
                <b-col cols="6">
                  <h5 class="fw-semi-bold text-muted mb-3">Today</h5>
                  <p class="text-muted mb-2 text-sm">This Week</p>
                  <p class="text-muted mb-2 text-sm">This Month</p>
                  <p class="text-muted mb-2 text-sm">This Quarter</p>
                  <p class="text-muted mb-2 text-sm">This Year</p>
                </b-col>
                <b-col cols="6">
                  <router-link
                    :to="{name:'AgingDetailsReport',query:{filter_by : '',interval_range:15,number_of_columns:4}}"
                    class="text-dark"
                  >
                    <h5
                      class="text-truncate fw-semi-bold mb-3"
                    >{{ orgCurrencySymbol }} {{ CheckNan(list.sal_rec_due_amt.tday_due_amt).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</h5>
                  </router-link>
                  <router-link
                    :to="{name:'AgingDetailsReport',query:{filter_by : '',interval_range:15,number_of_columns:4}}"
                  >
                    <p
                      class="text-truncate mb-2 text-sm"
                    >{{ orgCurrencySymbol }} {{ CheckNan(list.sal_rec_due_amt.week_due_amt).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</p>
                  </router-link>
                  <router-link
                    :to="{name:'AgingDetailsReport',query:{filter_by : '',interval_range:15,number_of_columns:4}}"
                  >
                    <p
                      class="text-truncate mb-2 text-sm"
                    >{{ orgCurrencySymbol }} {{ CheckNan(list.sal_rec_due_amt.month_due_amt).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</p>
                  </router-link>
                  <router-link
                    :to="{name:'AgingDetailsReport',query:{filter_by : '',interval_range:15,number_of_columns:4}}"
                  >
                    <p
                      class="text-truncate mb-2 text-sm"
                    >{{ orgCurrencySymbol }} {{ CheckNan(list.sal_rec_due_amt.quarter_due_amt).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</p>
                  </router-link>
                  <router-link
                    :to="{name:'AgingDetailsReport',query:{filter_by : '',interval_range:15,number_of_columns:4}}"
                  >
                    <p
                      class="text-truncate mb-2 text-sm"
                    >{{ orgCurrencySymbol }} {{ CheckNan(list.sal_rec_due_amt.year_due_amt).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</p>
                  </router-link>
                </b-col>
              </b-row>
            </Widget>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import needed functions, file , components and state
import { mapState, mapGetters } from "vuex";
import $ from "jquery";
import RecordNotFound from "@/pages/Error/RecordNotFound";

/* eslint-disable */
import "imports-loader?jQuery=jquery,this=>window!flot";
import "imports-loader?jQuery=jquery,this=>window!flot/jquery.flot.pie";
import "imports-loader?jQuery=jquery,this=>window!flot/jquery.flot.resize";
import "imports-loader?jQuery=jquery,this=>window!webpack-raphael/raphael";
import "imports-loader?jQuery=jquery,this=>window!govpredict-morris/morris";
/* eslint-enable */
import Widget from "@/components/Widget/Widget";
import store from "@/store/index"; // to call all vuex state
import { CheckNan } from "@/mixins/CheckNan"; // global fucntion for checking nan numbers
const { Morris } = window;
// function to done before route enter and before route update
function getPageDashboard(routeTo, next) {
  var data = JSON.stringify({
    graph_id: 1
  });
  store.dispatch("dashboard/fetchLists", data).then(() => {
    next();
  });
}
export default {
  name: "Dashboard",
  mixins: [CheckNan],
  components: {
    Widget,
    RecordNotFound
  },
  data() {
    return {};
  },
  methods: {
    dashboard_graph(range) {
      var data = JSON.stringify({
        graph_id: range
      });
      store.dispatch("dashboard/fetchLists", data).then(() => {
        this.initsalesreceiptbarchart();
      });
    },
    initsalesreceiptbarchart() {
      $(this.$refs.salesreceiptbarchart).html("");
      Morris.Bar({
        element: this.$refs.salesreceiptbarchart,
        resize: true,
        grid: false,
        xLabelMargin: 12,
        data: this.list.graph_details,
        xkey: "month",
        ykeys: ["total_sales", "total_receipts"],
        labels: ["Total Sales", "Total Receipts"],
        hideHover: "auto",
        barColors: ["#ffe1c3", "#c0dcfd"],
        gridTextColor: "#495057"
      });
    },
    getDueData() {
      const invoicedata = [
        this.CheckNan(this.list.due_amount.due_date_amt),
        this.CheckNan(this.list.due_amount.overdue_1_15_amt),
        this.CheckNan(this.list.due_amount.overdue_16_30_amt),
        this.CheckNan(this.list.due_amount.overdue_31_45_amt),
        this.CheckNan(this.list.due_amount.overdue_abv_45_amt)
      ];
      const billdata = [
        this.CheckNan(this.list.payable_due_amount.due_date_amt),
        this.CheckNan(this.list.payable_due_amount.overdue_1_15_amt),
        this.CheckNan(this.list.payable_due_amount.overdue_16_30_amt),
        this.CheckNan(this.list.payable_due_amount.overdue_31_45_amt),
        this.CheckNan(this.list.payable_due_amount.overdue_abv_45_amt)
      ];
      return {
        invoicedata: invoicedata,
        billdata: billdata
      };
    },
    initChart() {
      var duedatas = this.getDueData();
      var invocieduedata = duedatas.invoicedata.every(equal => equal == 0)
        ? { data: [100], colors: ["#ededed"] }
        : {
            data: duedatas.invoicedata,
            colors: ["#c9e7b8", "#fff8e3", "#c3e7e7", "#ffd7de", "#e2eaff"]
          };
      var billduedata = duedatas.billdata.every(equal => equal == 0)
        ? { data: [100], colors: ["#ededed"] }
        : {
            data: duedatas.billdata,
            colors: ["#c9e7b8", "#fff8e3", "#c3e7e7", "#ffd7de", "#e2eaff"]
          };
      $.plot($(this.$refs.invoicechartContainer), invocieduedata.data, {
        series: {
          pie: {
            innerRadius: 0.7,
            show: true,
            fill: 0.5
          }
        },
        colors: invocieduedata.colors
      });
      $.plot($(this.$refs.billschartContainer), billduedata.data, {
        series: {
          pie: {
            innerRadius: 0.7,
            show: true,
            fill: 0.5
          }
        },
        colors: billduedata.colors
      });
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    $(".content").addClass("dashboard-layout-color");
    getPageDashboard(routeTo, next); // function will be called before route enter ( to get all the api datas before page loading)
  },
  mounted() {
    this.initChart();
    window.addEventListener("resize", this.initChart);
    this.initsalesreceiptbarchart();
  },
  unmounted() {
    window.removeEventListener("resize", this.initChart);
  },
  computed: {
    ...mapState({
      list: state => state.dashboard.list // to show the data inside the table file: invoice.js
    }),
    ...mapGetters(["orgCurrencySymbol", "orgCurrency"])
  },
  beforeRouteLeave(to, from, next) {
    $(".content").removeClass("dashboard-layout-color");
    next();
  }
};
</script>
<style src="./Dashboard.scss" lang="scss" scoped />
